import { render, staticRenderFns } from "./demandPublishForm.vue?vue&type=template&id=27d7e4f1&scoped=true&"
import script from "./demandPublishForm.vue?vue&type=script&lang=js&"
export * from "./demandPublishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7e4f1",
  null
  
)

export default component.exports